export default (src) => !src || src.includes('//') ? src :`/images/${src}`;
